import {
    IPublicClientApplication,
    InteractionRequiredAuthError,
    InteractionStatus,
    RedirectRequest,
} from '@azure/msal-browser';

enum TokenErrors {
    InteractionInProgress = 'interaction_in_progress',
}

const handleResetAndRefresh = () => {
    localStorage.clear();
    setTimeout(() => { window.location.reload(); }, 100);
};

/*
 * This implementation follows incremental consent, and token acquisition is limited to one
 * resource at a time (scopes), but user can consent to many resources upfront (extraScopesToConsent)
 */
export const getAccessTokenUsingMsal = async (
    inProgress: InteractionStatus,
    msalInstance: IPublicClientApplication,
    scopes: string[],
    extraScopesToConsent?: string[],
) => {
    const account = msalInstance.getActiveAccount();
    
    if (!account) {
        handleResetAndRefresh();
        return "";
    }

    const authority = `https://login.microsoftonline.com/${account.tenantId}`;
    const accessTokenRequest: RedirectRequest = {
        authority,
        scopes,
        extraScopesToConsent,
        account,
    };

    return await acquireToken(accessTokenRequest, msalInstance, inProgress).catch((e) => {
        throw e;
    });
};

const acquireToken = async (
    accessTokenRequest: RedirectRequest,
    msalInstance: IPublicClientApplication,
    interactionStatus: InteractionStatus,
) => {
    return await msalInstance
        .acquireTokenSilent(accessTokenRequest)
        .then(function (accessTokenResponse) {
            return accessTokenResponse.accessToken;
        })
        .catch((error) => {
            if (error instanceof InteractionRequiredAuthError) {
                // Since app can trigger concurrent interactive requests, first check
                // if any other interaction is in progress proper to invoking a new one
                if (interactionStatus !== InteractionStatus.None) {
                    // throw a new error to be handled in the caller above
                    throw new Error(TokenErrors.InteractionInProgress);
                } else {
                    // Use redirect for token acquisition
                    void msalInstance.acquireTokenRedirect({ ...accessTokenRequest });
                    // Redirect does not return a token immediately
                    return "";
                }
            }
            throw new Error(`Received error while retrieving access token: ${error as string}`);
        });
};

export const TokenHelper = {
    getAccessTokenUsingMsal,
};
